<script setup lang="ts">
// TODO: make prop required once /[line]/[slug] has skeletons (not nullable)

import type { ProductLine } from '~/types/api'

const props = defineProps<{
  setNid?: number
  line: ProductLine | null
}>()

const { locale } = useI18n()
const localePath = useLocalePath()

const { data: smartFiltersData, status } = await useLazyAsyncData(
  'smartFilters_' + props.setNid + '_' + locale.value,
  () => createProductSetsRepository().getAllSmartFiltersByNid(props.setNid),
  {
    default: defaultPaginationObject,
  }
)

const isVisible = computed(() => {
  return (
    (status.value !== 'error' && !!smartFilters.value?.length) ||
    !!props.line?.footerDescription ||
    !!props.line?.fabricDescription
  )
})
const smartFilters = computed(() => smartFiltersData.value.items)
</script>

<template>
  <UiSection
    v-if="isVisible"
    :title="$t('productline.notes.title', [props.line?.title])"
  >
    <div v-if="props.line" class="my-5 flex flex-col gap-y-10 overflow-hidden">
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="props.line.footerDescription"
        v-html="props.line.footerDescription"
      />
      <div
        v-if="props.line.fabricDescription"
        v-html="props.line.fabricDescription"
      />
    </div>

    <template v-if="smartFilters.length">
      <h3 class="font-pragmatica-ext !text-xl">
        {{ $t('base.products.includedInCollections') }}
      </h3>
      <div class="mt-2 flex flex-wrap gap-2">
        <NuxtLink
          v-for="smartFilter in smartFilters"
          :key="smartFilter.nid"
          :to="
            localePath({
              name: 'products-slug',
              params: { slug: smartFilter.urlSlug },
            })
          "
        >
          {{ smartFilter.title }}
        </NuxtLink>
      </div>
    </template>
  </UiSection>
</template>
